import { TrafficCampaignSchema } from '@amzn/journeys-common';

/**
 * Default maximum ref tag character length used when schema is not found in config
 */
export const DEFAULT_REF_TAG_MAX_LENGTH = 64 as const;

/**
 * Configuration for maximum ref tag character lengths by schema type.
 *
 * This configuration allows different campaign schemas to have different
 * maximum ref tag lengths based on their specific requirements.
 */
export const REF_TAG_MAX_LENGTH_CONFIG: Partial<Record<TrafficCampaignSchema, number>> = {
  [TrafficCampaignSchema.FPC]: 32,
} as const;

/**
 * Gets the maximum ref tag character length for a given schema.
 * Returns the configured length for the schema, or the default if not configured.
 *
 * @param schema - The traffic campaign schema
 * @returns The maximum character length for ref tags
 */
export function getRefTagMaxLength(schema: TrafficCampaignSchema): number {
  return REF_TAG_MAX_LENGTH_CONFIG[schema] ?? DEFAULT_REF_TAG_MAX_LENGTH;
}
